import $ from 'jquery';
require('normalize.css/normalize.css');
require('../css/main.scss');
require('./page.scss');
import Cookies from 'js-cookie';
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp } from '../js/firebaseConfig';

$(document).ready(function() {
});